import api from "./api"

export const fnGetNewNotifications = async (cParams) => {
    const response = api.get(`/notification/queryNotification${cParams ? `?${cParams}` : ""}`);
    return response;
}
